export default "__VITE_ASSET__CIeOZ5h4__"